import { axiosLander } from '@/shared/plugins/axiosLander';
import axios from 'axios';
import { axiosBitrix } from '@/shared/plugins/axiosBitrix';
import { fixtures } from '@/app/modules/fixture';
import { Request } from '@/app/modules/request/Request';
import { registerApplier } from '@/app/libs/I';
import { requestService } from '@/app/modules/request/RequestService';

const targetsMap = {
  [Request.targets.LANDER]: axiosLander,
  [Request.targets.SVC]: axios,
  [Request.targets.BITRIX]: axiosBitrix,
};

registerApplier(requestService.applierId, async (request: Request) => {
  if (request.target === Request.targets.FIXTURE) {
    return fixtures[request.url]?.() ?? {};
  }

  const axiosInstance = targetsMap[request.target];

  const { data } = await axiosInstance.request({
    params: request.params,
    headers: request.headers,
    data: request.body,
    method: request.method,
    url: request.url,
  });

  return data;
});
